<template>
  <VMenu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    bottom
    left
    offset-y
  >
    <VBtn
      slot="activator"
      icon
    >
      <VIcon>notifications</VIcon>
    </VBtn>

    <VCard>
      <VList>
        <VListTile
          v-if="!notifications.length"
          avatar
        >
          <VListTileContent text-center>
            <VListTileSubTitle class="text-xs-center font-italic">
              {{ $nt('noContent') }}
            </VListTileSubTitle>
          </VListTileContent>
        </VListTile>
      </VList>
      <template v-for="notification in notifications">
        <VDivider :key="notification" />
      </template>
    </VCard>
  </VMenu>
</template>

<script>
export default {
  name: 'NotificationBlock',
  data () {
    return {
      menu: false,
      notifications: []
    }
  }
}
</script>

<style scoped>

</style>
